import { UserFacingError } from './errors'

export class HistoricalHuntNotFoundError extends UserFacingError {
  constructor() {
    super('This hunt record no longer exists.')
    this.name = 'HistoricalHuntNotFoundError'
  }
}
